/**
 * Referral capture — runs once at app boot.
 * Reads ?ref=XXX from the URL, stores it in localStorage `slowcafe_ref` for 30
 * days. Subsequent paid orders include the code in their checkout payload,
 * crediting the referrer RM 50.
 */

const KEY = "slowcafe_ref";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function captureReferralFromUrl() {
    try {
        const params = new URLSearchParams(window.location.search);
        const code = (params.get("ref") || "").toUpperCase().trim();
        if (!code) return null;

        // Persist with timestamp so we can expire it later
        window.localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }));

        // Fire-and-forget analytics ping
        const API = process.env.REACT_APP_BACKEND_URL;
        if (API) {
            fetch(`${API}/api/referrals/track`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    code,
                    path: window.location.pathname,
                    user_agent: (navigator.userAgent || "").slice(0, 280),
                }),
                keepalive: true,
            }).catch(() => { /* ignore */ });
        }
        return code;
    } catch {
        return null;
    }
}

export function getStoredReferral() {
    try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) return null;
        const obj = JSON.parse(raw);
        if (!obj?.code || !obj?.at) return null;
        if (Date.now() - obj.at > TTL_MS) {
            window.localStorage.removeItem(KEY);
            return null;
        }
        return obj.code;
    } catch {
        return null;
    }
}

export function clearStoredReferral() {
    try { window.localStorage.removeItem(KEY); } catch { /* */ }
}
